import React, { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { getSafeUserMessage } from "../../../utils/errorMessages";
import "../ShopOrderDialog.css";

export default function ReturnQuantityDialog({ request, action, onClose, onConfirm }) {
  const field = action === "approve" ? "approvedQty" : "receivedQty";
  const [quantities, setQuantities] = useState(() => Object.fromEntries(request.items.map((item) =>
    [item.lineId, action === "approve" ? item.qty : item.receivedQty || 0])));
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const title = action === "approve" ? "Approve Return Quantities" : action === "receive" ? "Receive Return Quantities" : "Reject Return";
  return <Modal className="shop-order-dialog" backdropClassName="shop-order-dialog-backdrop" show onHide={() => { if (!busy) onClose(); }} centered scrollable>
    <Form className="d-flex flex-column overflow-hidden" onSubmit={async (event) => {
      event.preventDefault(); if (busy) return; setBusy(true); setError("");
      try {
        await onConfirm({ note, reason: note, items: Object.entries(quantities).map(([lineId, qty]) => ({ lineId, [field]: Number(qty) })) });
        onClose();
      } catch (err) { setError(getSafeUserMessage(err.message, "Return could not be updated.")); }
      finally { setBusy(false); }
    }}>
      <Modal.Header closeButton={!busy}><Modal.Title>{title}</Modal.Title></Modal.Header>
      <Modal.Body>
        {action !== "reject" ? request.items.map((item) => <Form.Group className="mb-3" key={item.lineId} controlId={`quantity-${item.lineId}`}>
          <Form.Label>{item.productName} {item.variantName || item.variantType} ({item.sku || item.variantSku})</Form.Label>
          <Form.Control required disabled={busy} type="number" step="1" min={action === "receive" ? item.receivedQty || 0 : 0}
            max={action === "approve" ? item.qty : item.approvedQty} value={quantities[item.lineId]}
            onChange={(event) => setQuantities({ ...quantities, [item.lineId]: event.target.value })} />
        </Form.Group>) : null}
        <Form.Group controlId="return-admin-note"><Form.Label>{action === "reject" ? "Rejection reason" : "Note (optional)"}</Form.Label>
          <Form.Control required={action === "reject"} disabled={busy} as="textarea" maxLength={2000} value={note} onChange={(event) => setNote(event.target.value)} />
        </Form.Group>
        {error ? <p role="alert">{error}</p> : null}
      </Modal.Body>
      <Modal.Footer><Button variant="secondary" disabled={busy} onClick={onClose}>Back</Button><Button type="submit" variant="dark" disabled={busy}>{busy ? "Saving..." : "Confirm"}</Button></Modal.Footer>
    </Form>
  </Modal>;
}
